import React, { memo } from "react";
import { Theme } from "@mui/material";
import clsx from "clsx";
import { Add, Remove, SettingsBackupRestore } from "@mui/icons-material";
import isEqual from "react-fast-compare";
import { Box, Button, ButtonGroup, Tooltip, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  text: {
    marginTop: theme.spacing(1),
  },
  wrapper: {
    zIndex: 3,
    position: "relative",
  },
}));

type PropTypes = {
  scale: number;
  className?: string;
  disableZoomIn: boolean;
  zoomIn(): void;
  zoomOut(): void;
  resetTransform(): void;
};

const ZoomInOut = ({
  scale,
  className,
  disableZoomIn,
  zoomIn,
  zoomOut,
  resetTransform,
}: PropTypes) => {
  const classes = useStyles();
  return (
    <Box data-zoom={scale} className={clsx(classes.wrapper, className)}>
      <ButtonGroup orientation="vertical" color="secondary" variant="contained">
        <Tooltip title={"Zoom in"} placement="left-start">
          <span>
            <Button
              size={"small"}
              disabled={disableZoomIn}
              onClick={() => zoomIn()}
            >
              <Add fontSize={"small"} />
            </Button>
          </span>
        </Tooltip>
        <Tooltip title={"Zoom out"} placement="left-start">
          <span>
            <Button
              size={"small"}
              disabled={scale <= 1}
              onClick={() => zoomOut()}
            >
              <Remove fontSize={"small"} />
            </Button>
          </span>
        </Tooltip>
        <Tooltip title={"Reset zoom"} placement="left-start">
          <Button size={"small"} onClick={() => resetTransform()}>
            <SettingsBackupRestore fontSize={"small"} />
          </Button>
        </Tooltip>
      </ButtonGroup>
      {scale !== 1 ? (
        <Typography
          className={classes.text}
          variant={"subtitle2"}
          align={"center"}
          display={"block"}
        >
          {Math.round(scale)}x
        </Typography>
      ) : null}
    </Box>
  );
};

export default memo(ZoomInOut, isEqual);
